import moment from "moment";
import { beetwenDates } from "./Dates";
import { instance } from "./session/axios";
import { saveReload } from "./SessionStorage";

const gettingMultiRead = async (
  setLoading,
  range,
  employees,
  smartgroups,
  setRows,
  handlerAlert,
) => {
  if (
    JSON.parse(sessionStorage.getItem("privileges")).employees
      .get_info_employees
  ) {
    setLoading(true);

    const body = {
      start_date: range[0].format("YYYY-MM-DD"),
      end_date: range[1].format("YYYY-MM-DD"),
      employees,
    };

    await instance
      .post("person/multi_read", body)
      .then((response) => {
        const rows = [];

        for (const person_number of Object.keys(response.data)) {
          const labor = response.data[person_number].labor_accounts.find(
            (labor) =>
              beetwenDates(
                [range[0].format("YYYY-MM-DD"), range[1].format("YYYY-MM-DD")],
                [labor.effective_date, labor.expiration_date],
              ),
          );

          if (
            rows.find(
              (row) =>
                row.id ===
                response.data[person_number].person_data.person_number,
            ) === undefined
          ) {
            const employment_status =
              response.data[person_number]?.employment_status[
                response.data[person_number].employment_status.length - 1
              ];

            // console.log(
            //   "1",
            //   response.data[person_number]?.employment_status,
            //   "2",
            //   employment_status,
            //   "3",
            //   person_number
            // );

            const active = ["Activo", "Active"].some(
              (e) => e === employment_status?.status,
            );

            const term_date = active
              ? employment_status?.expiration_date
              : employment_status?.effective_date;
            const hire_date = moment(
              response.data[person_number]?.person_data.hire_date,
              ["DD/MM/YYYY", "YYYY-MM-DD"],
            ).format("DD/MM/YYYY");

            rows.push({
              id: response.data[person_number].person_data.person_number,
              person_number:
                response.data[person_number].person_data.person_number,
              full_name: response.data[person_number].person_data.full_name,
              hire_date: hire_date,
              term_date: moment(term_date, ["DD/MM/YYYY", "YYYY-MM-DD"]).format(
                "DD/MM/YYYY",
              ),
              closed_period: moment(
                response.data[person_number].person_data
                  .mgr_sign_off_thru_datetime,
                ["DD/MM/YYYY", "YYYY-MM-DD"],
              ).format("DD/MM/YYYY"),
              org_path: labor?.labor_account_description,
              active,
              custom_data: response.data[person_number].custom_data,
            });
          }
        }

        setRows(rows.sort((a, b) => a.full_name.localeCompare(b.full_name))); //setRows(data.sort((a, b) => a.full_name.localeCompare(b.full_name)))

        saveReload(
          "employees",
          range[0].format("YYYY-MM-DD"),
          range[1].format("YYYY-MM-DD"),
          smartgroups,
          employees,
        );
      })
      .catch((error) => {
        handlerAlert(
          "employee_table.alerts.error_get_info_employees.title",
          "employee_table.alerts.error_get_info_employees.message",
          "error",
        );

        console.error(error.message);
      })
      .finally(() => {
        /* const data = JSON.parse(sessionStorage.getItem('employees'))

            if(data){
                sessionStorage.setItem('employees', JSON.stringify({ 
                    environment: data?.environment ? data.environment : null,
                    redirect: null
                }))
            } */

        setLoading(false);
      });
  } else {
    handlerAlert(
      "employee_table.alerts.get_info_employees.title",
      "employee_table.alerts.get_info_employees.message",
      "error",
    );
  }
};

const updateCustomData = async (setLoading, personNumber, customData, handlerAlert) => {
  setLoading(true);

  const today = moment().format("YYYY-MM-DD");

  try {
    const response = await instance.post("person/multi_read", {
      start_date: today,
      end_date: today,
      employees: [personNumber],
    });

    const personData = response.data[personNumber];
    const laborAccount = personData.labor_accounts?.[0];

    const body = {
      person_data: {
        person_number: personData.person_data.person_number,
        birthdate: moment(personData.person_data.birthdate, [
          "DD/MM/YYYY",
          "YYYY-MM-DD",
        ]).format("YYYY-MM-DD"),
        first_name: personData.person_data.first_name,
        last_name: personData.person_data.last_name,
        email_address: personData.email_address?.[0]?.address || "",
        labor_account_name: laborAccount?.labor_account_name || "",
        labor_effective_date: moment(laborAccount?.effective_date, [
          "DD/MM/YYYY",
          "YYYY-MM-DD",
        ]).format("YYYY-MM-DD"),
        custom_data: customData,
      },
    };

    await instance.put("person/update", body);

    return true;
  } catch (error) {
    handlerAlert(
      "employee_table.alerts.error_update_custom_data.title",
      "employee_table.alerts.error_update_custom_data.message",
      "error",
    );

    return false;
  } finally {
    setLoading(false);
  }
};

export { gettingMultiRead, updateCustomData };
